import React from "react";
import styled from "styled-components";
export const ICON = styled.div``;
ICON.displayName = "ICON";

export const UsernameAvatar = styled.div`
	padding: 0;
	width: 60px;
	height: 60px;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 10px;
	border-radius: 40px;
	background: var(--avatar-bg);
	border: 1px solid var(--main-color-light);

	.initial {
		position: absolute;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-50%, -50%);
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
		color: var(--avatar-text-color);
		text-align: center;
		font-size: 35px !important;
		font-weight: 800;
		line-height: 35px;
		-webkit-letter-spacing: 0.75px;
		-moz-letter-spacing: 0.75px;
		-ms-letter-spacing: 0.75px;
		letter-spacing: 0.75px;
	}
`;
UsernameAvatar.displayName = "UsernameAvatar";

export default function TenantIcon({ width = 64, hasLetter, username }) {
	return hasLetter ? (
		<UsernameAvatar>
			<span className="initial">{username}</span>
		</UsernameAvatar>
	) : (
		<img
			width={width}
			src="/profile.svg"
			alt="profile"
		/>
	);
}
